import styles from "./search.module.css"
import { useEffect, useState, useCallback, useMemo } from "react"
import { useMediaQuery } from "react-responsive"
import { useDispatch, useSelector } from "react-redux"
import arrowImgPopular from "../../images/sort-arrow-popular.svg"
import arrowDownGreen from "../../images/arrow-down-sign-to-navigate-green.svg"
import arrowDownGray from "../../images/arrow-down-sign-to-navigate-svg.svg"
// import arrowDownGrayNotActive from "../../images/arrow-down-sign-not-active-svg.svg"
import filterIcon from "../../images/filter-svg.svg"
import filterUseIcon from "../../images/filter-use-svg.svg"
import closeXSign from "../../images/close-x-sign-svg.svg"
import RelevantSection from "../relevant-section/RelevantSection"
import SectionCheckBoxPoints from "../check-box-section/SectionCheckBoxPoints"
import FilterSection from "../filters-section/FilterSection"
import SectionSectorCheckBoxPoints from "../check-box-section-sector/SectionSectorCheckBoxPoints"
import ChackBoxChoiseSection from "../check-box-choise-section/ChackBoxChoiseSection"
import SectionCompanyCheckBoxPoints from "../check-box-section-company/SectionCompanyCheckBoxPoints"
import { useActiveButtonCountryTagChoice } from "../../services/context/CountryFilterContext"
import { useActiveFilters } from "../../services/context/ActiveFiltersContext"
import SearchSectionFast from "../searchFast/searchFast"
import {
  setCategoryPoints,
  setCountryPoints,
  setSectorPoints,
  setClearCompanyPoints,
} from "../../services/reducers/cards-filtred-slice"
import {
  setSelectCategoryPoint,
  setSelectCountryPoint,
  setSelectSectorPoint,
  setClearSelectCompanyPoint,
} from "../../services/reducers/search-vision-points-slice"
import {
  selectOrderingVision,
  categoryPrefilterSetPoints,
  selectCategoryVision,
  countryPrefilterSetPoints,
  selectCountryVision,
  sectorPrefilterSetPoints,
  selectSectorVision,
  companyPrefilterSetPoints,
  companyCategoryVision,
  checkBoxChoiceVision,
  selectAnalysisVision,
  selectSubscriptionVision,
  selectBondsVision,
  countryToApi,
  sectorToApi,
  categoryToApi,
} from "../../services/selectors"
const SearchSection = () => {
  const filters = useActiveFilters()
  const countryPreference = useActiveButtonCountryTagChoice()
  const dispatch = useDispatch()

  const selectRelevant = useSelector(selectOrderingVision)

  const categoryPoints = useSelector(categoryPrefilterSetPoints)
  const selectCategoryPoint = useSelector(selectCategoryVision)

  const countryPoints = useSelector(countryPrefilterSetPoints)
  const selectCountryPoint = useSelector(selectCountryVision)

  const sectorPoints = useSelector(sectorPrefilterSetPoints)
  const selectSectorPoint = useSelector(selectSectorVision)

  const companyPoints = useSelector(companyPrefilterSetPoints)
  const selectCompanyPoint = useSelector(companyCategoryVision)

  const checkBoxChoice = useSelector(checkBoxChoiceVision)

  const selectAnalysisPoint = useSelector(selectAnalysisVision)
  const selectSubscriptionPoint = useSelector(selectSubscriptionVision)
  const selectBondsPoint = useSelector(selectBondsVision)
  // // ===================== selector for API =============
  const countryPointsForApi = useSelector(countryToApi)
  const sectorPointsForApi = useSelector(sectorToApi)
  const categoryPointsForApi = useSelector(categoryToApi)

  const [mobileFilterSwich, setMobileFilterSwitch] = useState(false)
  const [activRelevantWind, setActivRelevantWind] = useState(false)
  const [activTypeMenu, setActivTypeMenu] = useState(false)
  const [activCountryMenu, setActivCountryMenu] = useState(false)
  const [activSectorMenu, setActivSectorMenu] = useState(false)
  const [activCompanyMenu, setActivCompanyMenu] = useState(false)

  useEffect(() => {
    if (isMobile) {
      if (mobileFilterSwich) {
        document.body.style.overflow = "hidden"
      }
      if (!mobileFilterSwich) {
        document.body.style.overflow = ""
      }
    }
  }, [mobileFilterSwich])

  // Мобильный State
  const closeAllFilters = () => {
    setActivRelevantWind(false)
    setActivTypeMenu(false)
    setActivCountryMenu(false)
    setActivSectorMenu(false)
    setActivCompanyMenu(false)
    setMobileFilterSwitch(false)
  }

  useMemo(() => {
    countryPreference.setAllPointsToFilters()
  }, [countryPreference.popUpChoice])
  // console.log(countryPointsForApi);

  useMemo(() => {
    filters.setCompanyForFilters(
      countryPointsForApi,
      sectorPointsForApi,
      categoryPointsForApi,
      selectAnalysisPoint,
      selectSubscriptionPoint,
      selectBondsPoint
    )
  }, [
    selectSectorPoint,
    selectCountryPoint,
    categoryPointsForApi,
    selectAnalysisPoint,
    selectSubscriptionPoint,
    selectBondsPoint,
  ])

  const isMobile = useMediaQuery({ query: "(max-width: 760px)" })

  const stringUnderSectionMobile = (choices) => {
    const nameFromObj = choices.map((el) => el.name)

    if (!!choices[0].fullname) {
      return choices.map((el) => el.fullname).join(", ")
    }
    return nameFromObj.join(", ")
  }

  const singleOpener = useCallback((filterName) => {
    switch (filterName) {
      // case '0':
      case "setActivTypeMenu":
        setActivTypeMenu((prev) => !prev)
        setActivCountryMenu(false)
        setActivSectorMenu(false)
        setActivCompanyMenu(false)

        break

      case "setActivCountryMenu":
        setActivCountryMenu((prev) => !prev)
        setActivTypeMenu(false)
        setActivSectorMenu(false)
        setActivCompanyMenu(false)

        break

      case "setActivSectorMenu":
        setActivSectorMenu((prev) => !prev)
        setActivTypeMenu(false)
        setActivCountryMenu(false)
        setActivCompanyMenu(false)
        break

      case "setActivCompanyMenu":
        setActivCompanyMenu((prev) => !prev)
        setActivSectorMenu(false)
        setActivTypeMenu(false)
        setActivCountryMenu(false)
    }
  }, [])

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.mainTxt}>Новости и аналитика</div>

        {!isMobile && (
          <SearchSectionFast
            selectRelevant={selectRelevant}
            setActivRelevantWind={setActivRelevantWind}
          />
        )}

        <div className={styles.sectionsWrapper}>
          <div className={styles.firstSection}>
            {/* Фильтры */}
            {!isMobile && (
              <div className={styles.filters}>
                {/* Кнопка - Тип */}
                <div className={styles.sectionFilterWrapper}>
                  <div
                    className={styles.typeBox}
                    onClick={() => {
                      singleOpener("setActivTypeMenu")
                    }}
                    // onClick={() => {setActivTypeMenu((prev) => !prev)}}
                  >
                    <div className={styles.selectBoxWrapper}>
                      <div className={styles.txtFilter}>
                        Тип
                        {selectCategoryPoint.length !== 0 && (
                          <div className={styles.pointCount}>
                            {selectCategoryPoint.length}
                          </div>
                        )}
                      </div>
                      <img
                        alt="img"
                        src={arrowDownGray}
                        className={styles.arrowDownGray}
                      />
                    </div>
                  </div>

                  {/* Фильтры - Тип */}
                  <div className={styles.filtersSection}>
                    {activTypeMenu && (
                      <FilterSection
                        categoryPoints={categoryPoints}
                        // setSelectCategoryPoint={setSelectCategoryPoint}
                        // setActivTypeMenu={setActivTypeMenu}
                        selectCategoryPoint={selectCategoryPoint}
                        // setCheckBoxChoice={setCheckBoxChoice}
                        checkBoxChoice={checkBoxChoice}
                        selectCompanyPoint={selectCompanyPoint}
                        // setSelectCompanyPoint={setSelectCompanyPoint}
                      />
                    )}
                  </div>
                </div>

                {/* Кнопка - Страна */}
                <div className={styles.sectionFilterWrapper}>
                  <div
                    className={styles.typeBox}
                    onClick={() => {
                      singleOpener("setActivCountryMenu")
                    }}

                    // onClick={() => {
                    //   setActivCountryMenu((prev) => !prev)
                    // }}
                  >
                    <div className={styles.selectBoxWrapper}>
                      <div className={styles.txtFilter}>
                        <div className={styles.txt}>Страна</div>
                        {selectCountryPoint.length !== 0 && (
                          <div className={styles.pointCount}>
                            {selectCountryPoint.length}
                          </div>
                        )}
                      </div>

                      <img
                        alt="img"
                        src={arrowDownGray}
                        className={styles.arrowDownGray}
                      />
                    </div>
                  </div>

                  {/* Фильтры - Страна */}
                  <div
                    className={styles.filtersSection}
                    // onMouseLeave={() => setActivCountryMenu(false)}
                  >
                    {activCountryMenu && (
                      <SectionCheckBoxPoints
                        countryPoints={countryPoints}
                        // setSelectCountryPoint={setSelectCountryPoint}
                        selectCountryPoint={selectCountryPoint}
                        // // // setCheckBoxChoice={setCheckBoxChoice}
                        checkBoxChoice={checkBoxChoice}
                        selectCompanyPoint={selectCompanyPoint}
                        // setSelectCompanyPoint={setSelectCompanyPoint}
                      />
                    )}
                  </div>
                </div>

                {/* Кнопка - Сектор */}
                <div className={styles.sectionFilterWrapper}>
                  <div
                    className={styles.typeBox}
                    onClick={() => {
                      singleOpener("setActivSectorMenu")
                      // setActivSectorMenu((prev) => !prev)
                    }}
                  >
                    <div className={styles.selectBoxWrapper}>
                      <div className={styles.txtFilter}>
                        <div className={styles.txt}>Сектор</div>
                        {selectSectorPoint.length !== 0 && (
                          <div className={styles.pointCount}>
                            {selectSectorPoint.length}
                          </div>
                        )}
                      </div>

                      <img
                        alt="img"
                        src={arrowDownGray}
                        className={styles.arrowDownGray}
                      />
                    </div>
                  </div>

                  {/* Фильтры - Сектор */}

                  <div
                    className={styles.filtersSection}
                    // onMouseLeave={() => setActivSectorMenu(false)}
                  >
                    {activSectorMenu && (
                      <SectionSectorCheckBoxPoints
                        sectorPoints={sectorPoints}
                        // // setCheckBoxChoice={setCheckBoxChoice}
                        checkBoxChoice={checkBoxChoice}
                        // setSelectSectorPoint={setSelectSectorPoint}
                        selectSectorPoint={selectSectorPoint}
                        selectCompanyPoint={selectCompanyPoint}
                        // setSelectCompanyPoint={setSelectCompanyPoint}
                      />
                    )}
                  </div>
                </div>

                {/* Кнопка - Компания */}
                <div className={styles.sectionFilterWrapper}>
                  {/*
                  {selectSectorPoint.length !== 0 ? (
                  */}
                  <div
                    className={styles.typeBox}
                    onClick={() => {
                      // setActivCompanyMenu((prev) => !prev)
                      singleOpener("setActivCompanyMenu")
                    }}
                  >
                    <div className={styles.selectBoxWrapper}>
                      <div className={styles.txtFilter}>
                        <div className={styles.txt}>Компания</div>
                        {selectCompanyPoint.length !== 0 && (
                          <div className={styles.pointCount}>
                            {selectCompanyPoint.length}
                          </div>
                        )}
                      </div>

                      <img
                        alt="img"
                        src={arrowDownGray}
                        className={styles.arrowDownGray}
                      />
                    </div>
                  </div>
                  {/*
                  ) : (
                    <div className={styles.typeBox}>
                      <div className={styles.noActiveBoxWrapper}>
                        <div className={styles.txtFilter}>
                          <div className={styles.txt}>Компания</div>
                        </div>
                        <img
                          alt="img"
                          src={arrowDownGrayNotActive}
                          className={styles.arrowDownGray}
                        />
                      </div>
                    </div>
                  )}
                  */}

                  {/* Фильтры - Компании */}
                  {activCompanyMenu && (
                    <div className={styles.filtersSection}>
                      {activCompanyMenu && (
                        <SectionCompanyCheckBoxPoints
                          // companyPoints={companyPoints}
                          companyPoints={companyPoints}
                          // setSelectCompanyPoint={setSelectCompanyPoint}
                          selectCompanyPoint={selectCompanyPoint}
                          // // setCheckBoxChoice={setCheckBoxChoice}
                          checkBoxChoice={checkBoxChoice}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/*  Мобильная версия */}

            {mobileFilterSwich && (
              <div className={styles.filters}>
                <div className={styles.mobileFilterTxt}>Фильтры</div>
                <div className={styles.filtersScrollWrapper}>
                  <div className={styles.sectionFilterWrapper}>
                    {selectCategoryPoint.length === 0 && (
                      <div
                        className={styles.typeBox}
                        onClick={() => {
                          setActivTypeMenu((prev) => !prev)
                        }}
                      >
                        <div className={styles.selectBoxWrapper}>
                          <div className={styles.txtFilter}>
                            <div className={styles.txt}>Тип</div>
                          </div>

                          <img
                            alt="img"
                            src={arrowDownGray}
                            className={styles.arrowDownGray}
                          />
                        </div>
                      </div>
                    )}

                    {selectCategoryPoint.length !== 0 && (
                      <div className={styles.typeBox}>
                        <div className={styles.mobileActiveBoxWrapper}>
                          <div
                            className={styles.noActiveContent}
                            onClick={() => {
                              setActivTypeMenu((prev) => !prev)
                            }}
                          >
                            <div className={styles.txtAct}>
                              <div className={styles.txtWrapper}>Тип</div>
                              <img
                                alt="img"
                                src={arrowDownGray}
                                className={styles.arrowDownGray}
                              />
                            </div>
                            <div className={styles.txtSmal}>
                              <div className={styles.stringUnderSection}>
                                {stringUnderSectionMobile(selectCategoryPoint)}
                              </div>
                            </div>
                          </div>
                          <div
                            className={styles.clearButton}
                            onClick={() => {
                              dispatch(setCategoryPoints([]))
                              dispatch(setSelectCategoryPoint([]))
                            }}
                          >
                            Сбросить
                          </div>
                        </div>
                      </div>
                    )}

                    <div className={styles.filtersSection}>
                      {activTypeMenu && (
                        <FilterSection
                          categoryPoints={categoryPoints}
                          // setSelectCategoryPoint={setSelectCategoryPoint}

                          setActivTypeMenu={setActivTypeMenu}
                          selectCategoryPoint={selectCategoryPoint}
                          // setCheckBoxChoice={setCheckBoxChoice}
                          checkBoxChoice={checkBoxChoice}
                          selectCompanyPoint={selectCompanyPoint}
                          // setSelectCompanyPoint={setSelectCompanyPoint}
                        />
                      )}
                    </div>
                  </div>

                  <div className={styles.sectionFilterWrapper}>
                    {selectCountryPoint.length === 0 && (
                      <div
                        className={styles.typeBox}
                        onClick={() => {
                          setActivCountryMenu((prev) => !prev)
                        }}
                      >
                        <div className={styles.selectBoxWrapper}>
                          <div className={styles.txtFilter}>
                            <div className={styles.txt}>Страна</div>
                          </div>

                          <img
                            alt="img"
                            src={arrowDownGray}
                            className={styles.arrowDownGray}
                          />
                        </div>
                      </div>
                    )}

                    {selectCountryPoint.length !== 0 && (
                      <div className={styles.typeBox}>
                        <div className={styles.mobileActiveBoxWrapper}>
                          <div
                            className={styles.noActiveContent}
                            onClick={() => {
                              setActivCountryMenu((prev) => !prev)
                            }}
                          >
                            <div className={styles.txtAct}>
                              <div className={styles.txtWrapper}>Страна</div>
                              <img
                                alt="img"
                                src={arrowDownGray}
                                className={styles.arrowDownGray}
                              />
                            </div>
                            <div className={styles.txtSmal}>
                              <div className={styles.stringUnderSection}>
                                {stringUnderSectionMobile(selectCountryPoint)}
                              </div>
                            </div>
                          </div>
                          <div
                            className={styles.clearButton}
                            onClick={() => {
                              // setSelectCountryPoint([])
                              dispatch(setCountryPoints([]))
                              dispatch(setSelectCountryPoint([]))
                              dispatch(setClearCompanyPoints())
                              dispatch(setClearSelectCompanyPoint())
                            }}
                          >
                            Сбросить
                          </div>
                        </div>
                      </div>
                    )}

                    <div className={styles.filtersSection}>
                      {activCountryMenu && (
                        <SectionCheckBoxPoints
                          countryPoints={countryPoints}
                          // setSelectCountryPoint={setSelectCountryPoint}
                          selectCountryPoint={selectCountryPoint}
                          // // // setCheckBoxChoice={setCheckBoxChoice}
                          checkBoxChoice={checkBoxChoice}
                          selectCompanyPoint={selectCompanyPoint}
                          setActivCountryMenu={setActivCountryMenu}
                          // setSelectCompanyPoint={setSelectCompanyPoint}
                        />
                      )}
                    </div>
                  </div>

                  <div className={styles.sectionFilterWrapper}>
                    {selectSectorPoint.length === 0 && (
                      <div
                        className={styles.typeBox}
                        onClick={() => {
                          setActivSectorMenu((prev) => !prev)
                        }}
                      >
                        <div className={styles.selectBoxWrapper}>
                          <div className={styles.txtFilter}>
                            <div className={styles.txt}>Сектор</div>
                          </div>

                          <img
                            alt="img"
                            src={arrowDownGray}
                            className={styles.arrowDownGray}
                          />
                        </div>
                      </div>
                    )}

                    {selectSectorPoint.length !== 0 && (
                      <div className={styles.typeBox}>
                        <div className={styles.mobileActiveBoxWrapper}>
                          <div
                            className={styles.noActiveContent}
                            onClick={() => {
                              setActivSectorMenu((prev) => !prev)
                            }}
                          >
                            <div className={styles.txtAct}>
                              <div className={styles.txtWrapper}>Сектор</div>
                              <img
                                alt="img"
                                src={arrowDownGray}
                                className={styles.arrowDownGray}
                              />
                            </div>
                            <div className={styles.txtSmal}>
                              <div className={styles.stringUnderSection}>
                                {stringUnderSectionMobile(selectSectorPoint)}
                              </div>
                            </div>
                          </div>
                          <div
                            className={styles.clearButton}
                            onClick={() => {
                              // setSelectSectorPoint([])

                              dispatch(setSectorPoints([]))
                              dispatch(setSelectSectorPoint([]))
                              dispatch(setClearCompanyPoints())
                              dispatch(setClearSelectCompanyPoint())
                            }}
                          >
                            Сбросить
                          </div>
                        </div>
                      </div>
                    )}

                    <div
                      className={styles.filtersSection}
                      // onMouseLeave={() => setActivSectorMenu(false)}
                    >
                      {activSectorMenu && (
                        <SectionSectorCheckBoxPoints
                          sectorPoints={sectorPoints}
                          // // setCheckBoxChoice={setCheckBoxChoice}
                          checkBoxChoice={checkBoxChoice}
                          // setSelectSectorPoint={setSelectSectorPoint}
                          selectSectorPoint={selectSectorPoint}
                          selectCompanyPoint={selectCompanyPoint}
                          setActivSectorMenu={setActivSectorMenu}
                          // setSelectCompanyPoint={setSelectCompanyPoint}
                        />
                      )}
                    </div>
                  </div>

                  <div className={styles.sectionFilterWrapper}>
                    {selectCompanyPoint.length === 0 && (
                      <div
                        className={styles.typeBox}
                        onClick={() => {
                          setActivCompanyMenu((prev) => !prev)
                        }}
                      >
                        <div className={styles.selectBoxWrapper}>
                          <div className={styles.txtFilter}>
                            <div className={styles.txt}>Компания</div>
                          </div>

                          <img
                            alt="img"
                            src={arrowDownGray}
                            className={styles.arrowDownGray}
                          />
                        </div>
                      </div>
                    )}

                    {/*
                  {selectSectorPoint.length !== 0 &&
                  */}
                    {selectCompanyPoint.length !== 0 && (
                      <div className={styles.typeBox}>
                        <div className={styles.mobileActiveBoxWrapper}>
                          <div
                            className={styles.noActiveContent}
                            onClick={() => {
                              setActivCompanyMenu((prev) => !prev)
                            }}
                          >
                            <div className={styles.txtAct}>
                              <div className={styles.txtWrapper}>Компания</div>
                              <img
                                alt="img"
                                src={arrowDownGray}
                                className={styles.arrowDownGray}
                              />
                            </div>
                            <div className={styles.txtSmal}>
                              <div className={styles.stringUnderSection}>
                                {stringUnderSectionMobile(selectCompanyPoint)}
                              </div>
                            </div>
                          </div>
                          <div
                            className={styles.clearButton}
                            onClick={() => {
                              dispatch(setClearCompanyPoints())
                              dispatch(setClearSelectCompanyPoint())
                            }}
                          >
                            Сбросить
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {/*
                  {selectSectorPoint.length === 0 && (
                    <div className={styles.typeBox}>
                      <div className={styles.noActiveBoxWrapper}>
                        <div className={styles.noActiveContent}>
                          <div className={styles.txtnoAct}>
                            <div className={styles.txtWrapper}>Компания</div>
                            <img
                              alt="img"
                              src={arrowDownGrayNotActive}
                              className={styles.arrowDownGray}
                            />
                          </div>
                          <div className={styles.txtSmal}>
                            Сначала выберите сектор
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  */}

                  {/*
                  {selectSectorPoint.length !== 0 && (
                  */}
                  <div className={styles.filtersSection}>
                    {activCompanyMenu && (
                      <SectionCompanyCheckBoxPoints
                        setActivCompanyMenu={setActivCompanyMenu}
                        // companyPoints={companyPoints}
                        companyPoints={companyPoints}
                        // setSelectCompanyPoint={setSelectCompanyPoint}
                        selectCompanyPoint={selectCompanyPoint}
                        // // setCheckBoxChoice={setCheckBoxChoice}
                        checkBoxChoice={checkBoxChoice}
                      />
                    )}
                  </div>

                  <SearchSectionFast
                    selectRelevant={selectRelevant}
                    setActivRelevantWind={setActivRelevantWind}
                  />

                  <div className={styles.underSpaceToScroll} />
                </div>

                <div className={styles.aceptButtonWrapper}>
                  <div
                    className={styles.acceptButtonActive}
                    onClick={() => {
                      closeAllFilters()
                    }}
                  >
                    Отфильтровать
                  </div>
                </div>
                <div className={styles.closeImg}>
                  <img
                    alt="img"
                    src={closeXSign}
                    onClick={() => {
                      closeAllFilters()
                    }}
                  />
                </div>
              </div>
            )}

            {/* КНОПКА - Сначала популярные*/}
            <div className={styles.sectionFilterWrapperOrdering}>
              {isMobile && (
                <div className={styles.relevantSectionMobileWrapper}>
                  <div
                    className={styles.relevantSection}
                    onClick={() => {
                      setActivRelevantWind((prev) => !prev)
                    }}
                  >
                    <img
                      alt="img"
                      src={arrowImgPopular}
                      className={styles.arrowImgPopular}
                    />
                    <div className={styles.txtButtom}>{selectRelevant}</div>
                    <img
                      alt="img"
                      src={arrowDownGreen}
                      className={styles.arrowDownGreen}
                    />
                  </div>
                </div>
              )}

              {/* Мобильная версия  */}
              {isMobile && (
                <div>
                  <div
                    className={styles.before}
                    onClick={() => {
                      setMobileFilterSwitch((prev) => !prev)
                    }}
                  >
                    Фильтр
                  </div>
                  {checkBoxChoice.length === 0 &&
                  selectCategoryPoint.length === 0 ? (
                    <img
                      alt="img"
                      src={filterIcon}
                      className={styles.filterIcon}
                      onClick={() => {
                        setMobileFilterSwitch((prev) => !prev)
                      }}
                    />
                  ) : (
                    <img
                      alt="img"
                      src={filterUseIcon}
                      className={styles.filterIcon}
                      onClick={() => {
                        setMobileFilterSwitch((prev) => !prev)
                      }}
                    />
                  )}
                </div>
              )}
              {/* ОТКРЫТЫЕ ФИЛЬТРЫ - Сначала популярные позиционируется от */}
              <div className={styles.filtersSectionOrderingWrapper}>
                <div className={styles.filtersSectionOrdering}>
                  {activRelevantWind && (
                    <RelevantSection
                      setActivRelevantWind={setActivRelevantWind}
                      selectRelevant={selectRelevant}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.chackBoxChoise}>
            {!isMobile && (
              <ChackBoxChoiseSection
                checkBoxChoice={checkBoxChoice}
                // setCheckBoxChoice={setCheckBoxChoice}
                selectCountryPoint={selectCountryPoint}
                // setSelectCountryPoint={setSelectCountryPoint}
                selectSectorPoint={selectSectorPoint}
                // setSelectSectorPoint={setSelectSectorPoint}
                selectCompanyPoint={selectCompanyPoint}
                // setSelectCompanyPoint={setSelectCompanyPoint}
                selectCategoryPoint={selectCategoryPoint}
                // setSelectCategoryPoint={setSelectCategoryPoint}
              />
            )}
          </div>

          {(activTypeMenu ||
            activCountryMenu ||
            activSectorMenu ||
            activCompanyMenu ||
            mobileFilterSwich ||
            activRelevantWind) && (
            <div
              className={styles.notActiveWindBut}
              onClick={() => {
                closeAllFilters()
              }}
            />
          )}
          {/*
          {activCountryMenu && (
            <div
              className={styles.notActiveWindBut}
              onClick={() => {
                closeAllFilters()
              }}
            />
          )}
          {activSectorMenu && (
            <div
              className={styles.notActiveWindBut}
              onClick={() => {
                closeAllFilters()
              }}
            />
          )}
          {activCompanyMenu && (
            <div
              className={styles.notActiveWindBut}
              onClick={() => {
                closeAllFilters()
              }}
            />
          )}
          {mobileFilterSwich && (
            <div
              className={styles.notActiveWindBut}
              onClick={() => {
                closeAllFilters()
              }}
            />
          )}
          {activRelevantWind && (
            <div
              className={styles.notActiveWindBut}
              onClick={() => {
                closeAllFilters()
              }}
            />
          )}
          */}
        </div>
      </div>
    </section>
  )
}
export default SearchSection
